import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import styled, {keyframes, withTheme} from 'styled-components';
import BaseTable, {AutoResizer} from 'react-base-table';
import 'react-base-table/styles.css'
import {Trans} from 'react-i18next';

const Empty = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Loader = styled.div`
  display: inline-block;
  border-radius: 100%;
  margin: 2px;
  border: 2px solid #0696d7;
  border-bottom-color: transparent;
  margin: 2px;
  width: ${props => (props.small ? 12 : 22)}px;
  height: ${props => (props.small ? 12 : 22)}px;
  animation: ${rotate} 0.75s linear infinite;
`

const LoadingLayer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0;
  width: 100%;
  height: 100%;
`

const LoadingMoreLayer = styled.div`
  pointer-events: none;
  background: rgba(32, 60, 94, 0.3);
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 15px;
  border-radius: 10px;
  display: flex;
  align-items: center;
`

const LoadingMoreText = styled.span`
  color: #fff;
  margin-left: 5px;
`

const SortOrder = {
  ASC: 'asc',
  DESC: 'desc',
}

const StyledTable = styled(BaseTable)`
  .BaseTable__table-main {
    outline-width: 0px;
  }
  .BaseTable__header-row {
    background-color: white;
    border-bottom: 2px solid #eeeeee;
  }
  .BaseTable__header-cell-text {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #6B778C;
  }
`
/*
  .BaseTable__row {
    border: none;
  }
*/
export default class DynamicTable extends PureComponent {
  static propTypes = {
    columns: PropTypes.any,
    data: PropTypes.any,
    fetching: PropTypes.bool,
    onLoadMore: PropTypes.func,
    onSortChanged: PropTypes.func,
    rowRenderer: PropTypes.func
  };
    
  constructor(props){
    super(props);
    this.state = {
      sortState: {},
    };
  }

  onColumnSort = ({key, order}) => {
    const {onSortChanged} = this.props;
    if (onSortChanged) {
      const sortState = {
        ...this.state.sortState,
        [key]: this.state.sortState[key] === SortOrder.DESC ? null : order
      };
      this.setState({sortState});
      let orderBy = {};
      Object.keys(sortState).map(key => sortState[key] ? orderBy[key] = sortState[key].toUpperCase() : null)
      onSortChanged(Object.keys(orderBy).length > 0 ? orderBy : null);
    }
  }

  renderEmpty = () => {
    const {data, fetching} = this.props;

    if (fetching || !data) {
      return null;
    }
    //return null;
    return <Empty><Trans>No Data</Trans></Empty>;
  }

  renderOverlay = () => {
    const {
      data,
      fetching,
    } = this.props;
    if (fetching) {
      if (data && data.length && data.length > 0) {
        return (
          <LoadingMoreLayer>
            <Loader small />
            <LoadingMoreText>
              <Trans>
                Loading
              </Trans>
            </LoadingMoreText>
          </LoadingMoreLayer>
        );
      }
      return (
        <LoadingLayer>
          <Loader />
        </LoadingLayer>
      );
    }
    return null
  }

  onRowClick = ({rowData}) => {
    this.props.history.push(
      `${this.props.match.url}/${rowData.id}`.replace('//','/')
    );
  }

  render () {
    const {
      columns,
      data,
      fetching,
      onLoadMore,
      permissions,
      ...otherProps
    } = this.props;
    const loadingMore = data && data.length && data.length > 0 && fetching;

    return (
      <AutoResizer>
        {({width, height}) => (
        <StyledTable
          style={{boxShadow:'none'}}
          columns={columns}
          data={data ? data : []}
          width={width}
          height={height}
          rowEventHandlers={permissions && {onClick: this.onRowClick}}
          onEndReachedThreshold={300}
          onEndReached={onLoadMore}
          sortState={this.state.sortState}
          onColumnSort={this.onColumnSort}
          disabled={fetching}
          loading={fetching}
          loadingMore={loadingMore}
          overlayRenderer={this.renderOverlay}
          emptyRenderer={this.renderEmpty}
          {...otherProps}
        />
        )}
      </AutoResizer>
    )
  }
}
